<form>

	<mat-form-field appearance="outline" class="date-search">
		<mat-date-range-input [formGroup]="dateRangeControl" [rangePicker]="picker">
			<input matStartDate formControlName="start" placeholder="Start date">
			<input matEndDate formControlName="end" placeholder="End date">
		</mat-date-range-input>
		<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
		<mat-date-range-picker #picker></mat-date-range-picker>
	</mat-form-field>

</form>

<div class="dci-metrics-container" *ngIf="dciMetrics">
  <mat-card>
    <mat-card-content>
      <mat-accordion multi>
        <!-- Base Metrics -->
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Base Metrics
            </mat-panel-title>
            <mat-panel-description>
              Overall completion and time metrics
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="metrics-section">
            <mat-list>
              <mat-list-item>Total Amount: {{ dciMetrics.base.totalAmount | number }}</mat-list-item>
              <mat-list-item>Total Completed: {{ dciMetrics.base.totalCompleted | number }}</mat-list-item>
              <mat-list-item>Total Started Not Completed: {{ dciMetrics.base.totalStartedNotCompleted | number }}</mat-list-item>
              <mat-list-item>Total Never Started: {{ dciMetrics.base.totalNeverStarted | number }}</mat-list-item>
              <mat-list-item>Average Time to Complete: {{ dciMetrics.base.averageTimeToComplete }} mins</mat-list-item>
              <mat-list-item>Min Time to Complete: {{ dciMetrics.base.minTimeToComplete }} mins</mat-list-item>
              <mat-list-item>Max Time to Complete: {{ dciMetrics.base.maxTimeToComplete }} mins</mat-list-item>
              <mat-list-item>Median Time to Complete: {{ dciMetrics.base.medianTimeToComplete }} mins</mat-list-item>
              <mat-list-item>Drop-off Rate: {{ dciMetrics.base.dropOffRate | number }}%</mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- Surveys Completed -->
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Surveys Completed
            </mat-panel-title>
            <mat-panel-description>
              Detailed survey completion statistics
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="metrics-section">
            <mat-list>
              <mat-list-item>Total Appointments: {{ dciMetrics.surveysCompleted.totalAppointments | number }}</mat-list-item>
              <mat-list-item>Total Surveys Sent Out: {{ dciMetrics.surveysCompleted.totalSurveySentOut | number }}</mat-list-item>
              <mat-list-item>Completed Before Appointment: {{ dciMetrics.surveysCompleted.totalSurveyCompletedBeforeAppointment | number }}</mat-list-item>
              <mat-list-item>Completed After Appointment: {{ dciMetrics.surveysCompleted.totalSurveyCompletedAfterAppointment | number }}</mat-list-item>
              <mat-list-item>Not Completed After Appointment: {{ dciMetrics.surveysCompleted.totalSurveyNotCompletedAfterAppointment | number }}</mat-list-item>
              <mat-list-item>Not Completed Before Appointment: {{ dciMetrics.surveysCompleted.totalSurveyNotCompletedBeforeAppointment | number }}</mat-list-item>
              <mat-list-item>Completion Rate: {{ dciMetrics.surveysCompleted.completionRatePercentage | percent }}</mat-list-item>
              <mat-list-item>Non-Completion Rate: {{ dciMetrics.surveysCompleted.nonCompletionRatePercentage | percent }}</mat-list-item>
              <mat-list-item>Average Hours Before Appointment Survey Completed: {{ dciMetrics.surveysCompleted.averageHoursBeforeAppointmentSurveyCompleted | number }} hrs</mat-list-item>
            </mat-list>

            <h3>Completed Survey Details:</h3>
            <div *ngIf="dciMetrics.surveysCompleted.completedSurveyDetails.length > 0; else noSurveyDetails">
              <table mat-table [dataSource]="dciMetrics.surveysCompleted.completedSurveyDetails" class="mat-elevation-z2">
                <!-- Range Column -->
                <ng-container matColumnDef="range">
                  <th mat-header-cell *matHeaderCellDef> Range </th>
                  <td mat-cell *matCellDef="let element"> {{element.range}} </td>
                </ng-container>

                <!-- Count Column -->
                <ng-container matColumnDef="count">
                  <th mat-header-cell *matHeaderCellDef> Count </th>
                  <td mat-cell *matCellDef="let element"> {{element.completedSurveyCount | number}} </td>
                </ng-container>

                <!-- Percentage Column -->
                <ng-container matColumnDef="percentage">
                  <th mat-header-cell *matHeaderCellDef> Percentage </th>
                  <td mat-cell *matCellDef="let element"> {{element.completedSurveyPercentage | percent}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['range', 'count', 'percentage']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['range', 'count', 'percentage'];"></tr>
              </table>
            </div>
            <ng-template #noSurveyDetails>
              <p>No completed survey details available.</p>
            </ng-template>
          </div>
        </mat-expansion-panel>

        <!-- Customer Satisfaction -->
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Customer Satisfaction
            </mat-panel-title>
            <mat-panel-description>
              Feedback and ratings
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="metrics-section">
            <h3>Comprehensive Rating:</h3>
            <div *ngFor="let item of dciMetrics.customerSatisfaction.comprehensive">
              <p>{{ item.key }}: {{ item.value }}</p>
            </div>

            <h3>Willingness to Retake in Future:</h3>
            <div *ngFor="let item of dciMetrics.customerSatisfaction.willingToRetakeInFuture">
              <p>{{ item.key }}: {{ item.value }}</p>
            </div>

            <h3>Ease Rating:</h3>
            <div *ngFor="let item of dciMetrics.customerSatisfaction.easeRating">
              <p>Rating {{ item.key }}: {{ item.value }}</p>
            </div>

            <h3>Time It Took:</h3>
            <div *ngFor="let item of dciMetrics.customerSatisfaction.timeItTook">
              <p>{{ item.key }}: {{ item.value }}</p>
            </div>

            <h3>Symptoms History:</h3>
            <div *ngFor="let item of dciMetrics.customerSatisfaction.symptomsHistory">
              <p>Level {{ item.key }}: {{ item.value }}</p>
            </div>

            <h3>Comments:</h3>
            <mat-list *ngIf="dciMetrics.customerSatisfaction.comments.length > 0; else noComments">
              <mat-list-item *ngFor="let comment of dciMetrics.customerSatisfaction.comments">
                <mat-icon matListItemIcon>comment</mat-icon>
                <div matListItemTitle>{{ comment }}</div>
              </mat-list-item>
            </mat-list>
            <ng-template #noComments>
              <p>No comments available.</p>
            </ng-template>
          </div>
        </mat-expansion-panel>

        <!-- MSK Pathways -->
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              MSK Pathways
            </mat-panel-title>
            <mat-panel-description>
              Musculoskeletal pathway statistics
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="metrics-section">
            <div *ngIf="dciMetrics.mskPathways.length > 0; else noMskPathways">
              <table mat-table [dataSource]="dciMetrics.mskPathways" class="mat-elevation-z2">
                <ng-container matColumnDef="category">
                  <th mat-header-cell *matHeaderCellDef> Category </th>
                  <td mat-cell *matCellDef="let element"> {{element.category}} </td>
                </ng-container>
                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef> Total </th>
                  <td mat-cell *matCellDef="let element"> {{element.totalAmount}} </td>
                </ng-container>
                <ng-container matColumnDef="ongoing">
                  <th mat-header-cell *matHeaderCellDef> Ongoing </th>
                  <td mat-cell *matCellDef="let element"> {{element.ongoingAmount}} </td>
                </ng-container>
                <ng-container matColumnDef="completed">
                  <th mat-header-cell *matHeaderCellDef> Completed </th>
                  <td mat-cell *matCellDef="let element"> {{element.completedAmount}} </td>
                </ng-container>
                <ng-container matColumnDef="accessRevoked">
                  <th mat-header-cell *matHeaderCellDef> Access Revoked </th>
                  <td mat-cell *matCellDef="let element"> {{element.accessRevokedAmount}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['category', 'total', 'ongoing', 'completed', 'accessRevoked']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['category', 'total', 'ongoing', 'completed', 'accessRevoked'];"></tr>
              </table>
            </div>
            <ng-template #noMskPathways>
              <p>No MSK pathway data available.</p>
            </ng-template>
          </div>
        </mat-expansion-panel>

        <!-- Other Pathway Body Responses -->
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Other Pathway Body Responses
            </mat-panel-title>
            <mat-panel-description>
              Responses for other body parts
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="metrics-section">
            <div *ngIf="dciMetrics.otherPathwayBodyResponses.length > 0; else noOtherBodyResponses">
              <table mat-table [dataSource]="dciMetrics.otherPathwayBodyResponses" class="mat-elevation-z2">
                <ng-container matColumnDef="bodyPart">
                  <th mat-header-cell *matHeaderCellDef> Body Part </th>
                  <td mat-cell *matCellDef="let element"> {{element.bodyPart}} </td>
                </ng-container>
                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef> Total Amount </th>
                  <td mat-cell *matCellDef="let element"> {{element.totalAmount}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['bodyPart', 'total']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['bodyPart', 'total'];"></tr>
              </table>
            </div>
            <ng-template #noOtherBodyResponses>
              <p>No other pathway body response data available.</p>
            </ng-template>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</div>